<template>
  <div class="detalle-oferta-panel">
    <DxTabPanel height="95%" tabs-position="top" icon-position="left" :defer-rendering="false">
      <DxItem 
        v-for="marco in marcosComisiones" 
        :key="marco.Id" 
        :title="marco.Denominacion" 
        class="tab-item" 
        :disabled="false" 
      >
        <oferta-energia-tab-comisiones-marco 
          :id-oferta="(model as DetailOfertaEnergiaModel).Id || ''" 
          :id-marco="marco.Id" 
          :is-edit-mode="isEditMode" 
          :ref="addTabRef">
        </oferta-energia-tab-comisiones-marco>
      </DxItem>
    </DxTabPanel>
  </div>
</template>

<script setup lang="ts">
import OfertaEnergiaTabComisionesMarco from '@/components/ofertas-energia/base/OfertaEnergiaTabComisionesMarco.vue';
import { ref } from 'vue';
import { type CreateOfertaEnergiaModel, type DetailOfertaEnergiaModel, type SelectBoxGuidEntityModel } from '@/.shared/.api';
import DxTabPanel, { DxItem } from 'devextreme-vue/tab-panel';
import { useApi } from '@/.shared/.api/integration';
import { onMounted } from 'vue';

const api = useApi();
const tabComisionesMarco = ref<InstanceType<typeof OfertaEnergiaTabComisionesMarco>[]>([]);
const marcosComisiones = ref<SelectBoxGuidEntityModel[]>([]);

const addTabRef = (el: any) => {
  if (el) {
    tabComisionesMarco.value.push(el);
  }
};

const props = defineProps({
  model: {
    type: Object as () => DetailOfertaEnergiaModel | CreateOfertaEnergiaModel,
    required: true
  },
  isEditMode: {
    type: Boolean,  
    required: true
  },
});

onMounted(async () => {
  marcosComisiones.value = await api.callStandardApi("getMarcosComisionesList", {showLoading: false});
});

defineExpose({
  getComisiones: () => {
    const comisiones: any[] = [];
    for (const tab of tabComisionesMarco.value) {
      const tabComisiones = tab.getComisiones();
      if (tabComisiones) {
        const comisionesConMarco = tabComisiones.map(comision => ({
          ...comision,
          idMarco: tab.idMarco
        }));
        comisiones.push(...comisionesConMarco);
      }
    }
    return comisiones;
  },
});

</script>